import type { TypePolicies } from "@apollo/client"

export const typePoliciesQueryFields: TypePolicies = {
  Query: {
    fields: {
      countryIntelligence: {
        merge(existing, incoming, { mergeObjects }) {
          return mergeObjects(existing, incoming)
        },
      },
      engagementChanges: {
        merge(existing = [], incoming = []) {
          return [...existing, incoming.collection]
        },
      },
    },
  },
}
